import { AlertModalSign } from './alert-modal-sign';
import { VendorSigningState } from './check-vendor-signing-properties-response-model';
import { VendorToNominate } from './vendor-to-nominate';
import { VpaApplicationRequestType } from './vpa-application-request-type';

export interface UnsignApplicationModalState {
  showModal: boolean;
  vendorsToUnsign: VendorSigningState[];
  vendorNamesToUnsign: string;
  step: UnsignFlowStep;
  nominatedVendorName: string;
  isNominatedVendorBeingUnsigned: boolean;
  isSendingInvitationToMultipleVendors: boolean;
  modalIcon: AlertModalSign;
  vendorsToNominateFrom: VendorToNominate[];
  selectedVendorName: string;
  applicantLabel: string;
}

export const createUnsignApplicationModalState = (
  vendorsToUnsign: VendorSigningState[],
  showUnsignApplicationModal: boolean,
  unsigningModalStep: UnsignFlowStep,
  nominatedVendorName: string,
  nominatedVendorId: number,
  vpaApplicationRequestType: VpaApplicationRequestType,
  vendorsToNominateFrom?: VendorToNominate[],
  selectedVendorIndex?: number
): UnsignApplicationModalState => {
  const isNominatedVendorBeingUnsigned = vendorsToUnsign.some((v) => v.vpaApplicationVendorId === nominatedVendorId);
  return {
    vendorsToUnsign,
    nominatedVendorName,
    isNominatedVendorBeingUnsigned,
    showModal: showUnsignApplicationModal,
    step: unsigningModalStep,
    vendorNamesToUnsign: vendorsToUnsign.reduce((prev, curr, ind, arr) => {
      if (ind === 0) {
        return curr.firstName;
      } else if (ind === arr.length - 1) {
        return `${prev} and ${curr.firstName}`;
      } else {
        return `${prev}, ${curr.firstName}`;
      }
    }, ''),
    isSendingInvitationToMultipleVendors: !isNominatedVendorBeingUnsigned && vendorsToUnsign.length > 1,
    modalIcon: unsigningModalStep === UnsignFlowStep.SelectNominatedVendor ? undefined : AlertModalSign.Warning,
    vendorsToNominateFrom: vendorsToNominateFrom ?? [],
    selectedVendorName: (vendorsToNominateFrom ?? []).find((v) => v.index === selectedVendorIndex)?.firstName,
    applicantLabel: mapApplicantLabel(vpaApplicationRequestType)
  };
};

const mapApplicantLabel = (vpaApplicationRequestType: VpaApplicationRequestType): string => {
  switch (vpaApplicationRequestType) {
    case VpaApplicationRequestType.PndAgentContribution:
      return 'agent';
    default:
      return 'vendor';
  }
};

export enum UnsignFlowStep {
  ShowChanges,
  SendInvitations,
  ChangeToVendorFlow,
  SelectNominatedVendor
}
